import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

/* 가변 폰트 + 동적 서브셋. 한글 전체를 unicode-range 로 93조각 낸 것이라
   브라우저가 화면에 실제로 뜬 글자의 조각만 받는다 — 통짜 2MB 대신 수십 KB. */
import "pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css";

import App from "./App.jsx";
import "./style.css";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
